export const STATUS_OPTIONS = {
  new: 'New',
  in_progress: 'In Progress',
  done: 'Done',
  declined: 'Declined',
  on_hold: 'On Hold',
}

export const TYPE_OPTIONS = {
  general: 'General',
  kyc: 'KYC',
  vip: 'VIP',
  support: 'Support',
  shift: 'Shift',
  qc: 'QC',
  personal: 'Personal',
}

export const ANALYTICS_GROUP_BY_OPTIONS = [
  { text: 'Priority', value: 'priority' },
  { text: 'Type', value: 'type' },
  { text: 'Status', value: 'status' },
  { text: 'Player', value: 'player_id' },
  { text: 'Author', value: 'author_id' },
  { text: 'Assignee', value: 'user_id' },
  { text: 'Performer', value: 'performer_id' },
  { text: 'Date', value: 'date' },
]

export const PRIORITY_OPTIONS = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
}

export const getEmptyTask = () => ({
  status: Object.keys(STATUS_OPTIONS)[0],
  user_id: null,
  date: '',
  type: Object.keys(TYPE_OPTIONS)[0],
  body: '',
  performer_id: null,
  priority: Object.keys(PRIORITY_OPTIONS)[0],
  tags: [],
})
